
export interface Question {
  text: string;
  options: string[];
  correctAnswer: number | number[];
  explanation: string;
}

export const questions: Question[] = [
  {
    text: "What is the most effective way to prevent the spread of foodborne illness?",
    options: [
      "Using hand sanitizer before cooking",
      "Washing hands thoroughly with warm water and soap for at least 20 seconds",
      "Rubbing hands with a dry towel before handling food",
      "Wearing gloves at all times, even if they are not clean"
    ],
    correctAnswer: 1,
    explanation: "Handwashing with soap and warm water for at least 20 seconds is the most effective way to remove bacteria and viruses. Hand sanitizer is not a substitute when hands are visibly dirty."
  },
  {
    text: "When must food handlers wash their hands? <strong>(Select all that apply)</strong>",
    options: [
      "Before starting food prep",
      "After touching raw meat, poultry, or seafood",
      "After handling money or a mobile phone",
      "Only if they can see dirt on their hands"
    ],
    correctAnswer: [0, 1, 2],
    explanation: "Hands should be washed before food prep, after handling raw food, after touching money, phones, or trash, and anytime contamination is possible—not just when visible dirt is present."
  },
  {
    text: "A cook with a small cut on their hand should:",
    options: [
      "Continue working as long as they avoid touching the food with the injured hand",
      "Wash the wound, apply a bandage, and wear a disposable glove",
      "Ignore the cut unless it starts bleeding",
      "Wash the cut with soap and rinse it under running water"
    ],
    correctAnswer: 1,
    explanation: "Open wounds can introduce bacteria into food. Covering the wound with a bandage and wearing gloves prevents contamination."
  },
  {
    text: "What is the minimum internal cooking temperature for poultry?",
    options: [
      "145°F",
      "155°F",
      "165°F",
      "175°F"
    ],
    correctAnswer: 2,
    explanation: "Poultry must be cooked to a minimum internal temperature of 165°F (74°C) to kill harmful bacteria."
  },
  {
    text: "How should you store raw meat in a refrigerator?",
    options: [
      "On the top shelf",
      "Next to ready-to-eat foods",
      "On the bottom shelf in sealed containers",
      "Anywhere there's space"
    ],
    correctAnswer: 2,
    explanation: "Raw meat should be stored on the bottom shelf in sealed containers to prevent juices from dripping onto other foods and causing cross-contamination."
  },
  {
    text: "What is the 'danger zone' temperature range for food?",
    options: [
      "0°F to 32°F",
      "40°F to 140°F",
      "165°F to 212°F",
      "Below 0°F"
    ],
    correctAnswer: 1,
    explanation: "The 'danger zone' is between 40°F and 140°F (4°C to 60°C), where bacteria multiply rapidly. Keep cold foods below 40°F and hot foods above 140°F."
  },
  {
    text: "How long can perishable food be left at room temperature?",
    options: [
      "No more than 2 hours",
      "Up to 4 hours",
      "Up to 6 hours",
      "Until it looks or smells bad"
    ],
    correctAnswer: 0,
    explanation: "Perishable food should not be left at room temperature for more than 2 hours. In hot weather (above 90°F), the limit is 1 hour."
  },
  {
    text: "What is cross-contamination?",
    options: [
      "Cooking different foods together",
      "Using the same cutting board for raw meat and vegetables",
      "Mixing different types of cleaning products",
      "Using expired ingredients"
    ],
    correctAnswer: 1,
    explanation: "Cross-contamination occurs when bacteria from one food item is transferred to another, often through shared cutting boards, utensils, or improper handling."
  },
  {
    text: "What is the correct order for washing dishes?",
    options: [
      "Rinse, wash, sanitize",
      "Wash, rinse, sanitize",
      "Sanitize, wash, rinse",
      "Wash, sanitize, rinse"
    ],
    correctAnswer: 1,
    explanation: "The correct order is wash (remove food and grease), rinse (remove soap), then sanitize (kill remaining bacteria)."
  },
  {
    text: "Which is NOT a common food allergen?",
    options: [
      "Soy",
      "Rice",
      "Peanuts",
      "Shellfish"
    ],
    correctAnswer: 1,
    explanation: "Rice is not one of the major food allergens. The main allergens include milk, eggs, fish, shellfish, tree nuts, peanuts, wheat, and soy."
  },
  {
    text: "What is the best way to thaw frozen food?",
    options: [
      "On the counter at room temperature",
      "In hot water",
      "In the refrigerator",
      "In the microwave on high power"
    ],
    correctAnswer: 2,
    explanation: "Thawing in the refrigerator is safest as it maintains a safe temperature throughout the thawing process."
  },
  {
    text: "How should you clean a cutting board after preparing raw chicken?",
    options: [
      "Wipe with a dry paper towel",
      "Rinse with hot water",
      "Wash with soap, then sanitize",
      "Use the dishwasher if it's plastic"
    ],
    correctAnswer: 2,
    explanation: "After handling raw chicken, cutting boards should be washed with hot soapy water and then sanitized to kill any remaining bacteria."
  },
  {
    text: "How often should you calibrate a food thermometer?",
    options: [
      "Once a year",
      "Never",
      "At least once per week",
      "Only when it breaks"
    ],
    correctAnswer: 2,
    explanation: "Food thermometers should be calibrated at least weekly to ensure accurate temperature readings and food safety."
  },
  {
    text: "What is the proper way to store cleaning chemicals?",
    options: [
      "Under the sink with food items",
      "In a separate, locked area away from food",
      "On top of food preparation surfaces",
      "Anywhere that's convenient"
    ],
    correctAnswer: 1,
    explanation: "Cleaning chemicals must be stored in a separate, locked area away from food to prevent contamination and accidents."
  },
  {
    text: "What should you do if you're sick with a fever or diarrhea?",
    options: [
      "Continue working but wear a mask",
      "Take medicine and keep cooking",
      "Work only on cold foods",
      "Do not handle food until all symptoms have passed"
    ],
    correctAnswer: 3,
    explanation: "Food handlers must not work when sick with fever, diarrhea, or other infectious conditions to prevent contamination."
  },
  {
    text: "What is the minimum internal cooking temperature for ground beef?",
    options: [
      "145°F",
      "155°F",
      "160°F",
      "165°F"
    ],
    correctAnswer: 2,
    explanation: "Ground beef must be cooked to a minimum internal temperature of 160°F (71°C) to kill harmful bacteria."
  },
  {
    text: "What is the best way to prevent foodborne illness?",
    options: [
      "Cooking food thoroughly",
      "Keeping food at room temperature",
      "Using the same utensils for raw and cooked food",
      "Ignoring expiration dates"
    ],
    correctAnswer: 0,
    explanation: "Cooking food thoroughly kills harmful bacteria and prevents foodborne illness."
  },
  {
    text: "What should you do if you find a hair in the food?",
    options: [
      "Remove the hair and continue serving",
      "Throw the food away",
      "Inform the customer",
      "Ignore it"
    ],
    correctAnswer: 1,
    explanation: "Finding a hair in food is a sign of poor hygiene, and the food should be discarded to maintain safety standards."
  },
  {
    text: "What is the proper way to handle leftovers?",
    options: [
      "Leave them out at room temperature",
      "Store them in the refrigerator within 2 hours",
      "Reheat them only once",
      "Use them within a week"
    ],
    correctAnswer: 1,
    explanation: "Leftovers should be stored in the refrigerator within 2 hours to prevent bacterial growth."
  },
  {
    text: "What is the correct way to wash fruits and vegetables?",
    options: [
      "Rinse under cold water",
      "Use soap and water",
      "Soak in bleach solution",
      "Wipe with a dry cloth"
    ],
    correctAnswer: 0,
    explanation: "Fruits and vegetables should be rinsed under cold water to remove dirt and pesticides."
  },
  {
    text: "What is the best way to prevent cross-contamination?",
    options: [
      "Using separate cutting boards for raw and cooked foods",
      "Washing hands frequently",
      "Cooking food to the right temperature",
      "All of the above"
    ],
    correctAnswer: 3,
    explanation: "Using separate cutting boards, washing hands, and cooking food properly all help prevent cross-contamination."
  },
  {
    text: "What should you do if you drop food on the floor?",
    options: [
      "Pick it up and serve it",
      "Throw it away",
      "Rinse it off and serve it",
      "Leave it there"
    ],
    correctAnswer: 1,
    explanation: "Food that has fallen on the floor should be discarded to prevent contamination."
  },
  {
    text: "What is the proper way to cool hot food?",
    options: [
      "Leave it out at room temperature",
      "Put it in the refrigerator immediately",
      "Use ice water bath",
      "Cover it and let it cool slowly"
    ],
    correctAnswer: 2,
    explanation: "Hot food should be cooled quickly using an ice water bath to prevent bacterial growth."
  },
  {
    text: "What is the best way to ensure food safety?",
    options: [
      "Following proper cooking temperatures",
      "Using fresh ingredients",
      "Keeping a clean kitchen",
      "All of the above"
    ],
    correctAnswer: 3,
    explanation: "Ensuring food safety involves following cooking temperatures, using fresh ingredients, and maintaining a clean kitchen."
  }
];
